/**
 * 登录上下文的 Context 与类型定义
 * ---------------------------------------------------------------------------
 * 单独放一个文件是为了配合 React Fast Refresh：
 * 组件文件里只导出组件，Context 和类型放这里，改代码时热更新不会整页刷新。
 */
import { createContext } from 'react';
import type { LoginInput } from '@/lib/api/endpoints/auth';
import type { AuthContext as AuthContextData, Store } from '@/lib/api/types';

export type AuthState = {
  /** 启动时正在校验本地 token，页面应显示加载态而不是登录页 */
  initializing: boolean;
  /** null 表示未登录 */
  user: AuthContextData | null;
  displayName: string;
  /** 当前账号可见的门店列表 */
  stores: Store[];
  /** 当前选中的门店；单店场景下就是唯一那家 */
  currentStore: Store | null;
  login: (input: LoginInput) => Promise<void>;
  logout: () => void;
  switchStore: (storeId: string) => void;
  /** 权限判断，传入权限码如 'order.create' */
  can: (permissionCode: string) => boolean;
};

export const AuthContext = createContext<AuthState | null>(null);
